module.exports = __webpack_public_path__ + "static/media/co2.89636a46.svg";